export class CategoryWiseActAndBudgetForLastThreeYears {
    divisionId: number;
    clientCode: string;
    isTotal: number;
    lastHowManyYears: number;
}